import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Box } from '@mui/material';
import { useRef, useState } from 'react';
import { useRootStore } from '../hooks/useRootStore';
import { MDXEditor, MDXEditorMethods } from '@mdxeditor/editor';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import moment from 'moment';
import { MdxPlugins } from './MarkdownEditor/MarkdownEditorPlugins';
import useDeviceMedia from '../hooks/useDeviceMedia';

export default function ChangeEstimatedDateDialog({ issueId, oldDate, onSubmit, onCancel }: { issueId: number, oldDate: Date | null, onSubmit: (newDate: Date | null) => void, onCancel: () => void }) {

    const [newDate, setNewDate] = useState(oldDate);
    const { isMobile, isMobilePortrait } = useDeviceMedia();

    const [textNotSpecified, setTextNotSpecified] = useState(false);
    const { api } = useRootStore();

    const changeDate = async () => {
        const comments = (mdxEditorRef.current?.getMarkdown() ?? '').trim();
        if (comments.trim().length == 0) {
            setTextNotSpecified(true);
            return false;
        } else {
            await api.updateIssueEstimatedDate(issueId, newDate, comments)
                .then(() => onSubmit(newDate));
        }
    }

    const mdxEditorRef = useRef<MDXEditorMethods>(null);

    return (
        <LocalizationProvider dateAdapter={AdapterMoment}>
            <Dialog
                maxWidth='lg'
                fullWidth
                open={true}
                onClose={onCancel}
            >
                <DialogTitle>{isMobilePortrait ? "Изменение срока" : "Изменение срока по задаче"}</DialogTitle>
                <DialogContent>
                    <DatePicker format="DD.MM.YYYY"
                        defaultValue={moment(oldDate)}
                        onChange={(e) => { if (e) setNewDate(e.toDate()) }}
                        sx={{ mb: 1, mt: 2 }}
                        label="Новый срок"
                    />
                    <Box sx={{ mt: 0.5, textAlign: 'left', minHeight: '300px', border: `1px solid ${textNotSpecified ? 'red' : '#cccccc'}`, borderRadius: 1 }} onClick={() => mdxEditorRef.current?.focus()}>
                        <MDXEditor
                            ref={mdxEditorRef}
                            markdown={''}
                            plugins={MdxPlugins.standardPlugins(api, issueId, '', isMobile)}
                            onChange={() => setTextNotSpecified(false)}
                        />
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={onCancel}>Отмена</Button>
                    <Button onClick={changeDate}>Изменить срок</Button>
                </DialogActions>
            </Dialog>
        </LocalizationProvider>
    );
}